import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Input, InputGroup, Label, Collapse, CardBody, Row, Col } from 'reactstrap';
import DefaultHeader from '../../container/defaultHeader/DefaultHeader';
import DefaultFooter from '../../container/defaultFooter/DefaultFooter';
import { withRouter } from 'react-router';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import consts from '../../util/Consts';
import { FaSortAmountDownAlt, FaSortAmountUp } from 'react-icons/fa'
import './TableGrid.css';

class TableGrid extends Component {

    PageSizeOptions = ['10', '25', '50'];
    currencyKeys = ["partCost", "extension", "cost", "liab", "amount"];

    constructor(props) {
        super(props);
        this.state = {
            showSidebar: false,
            dropdownOpen: false,
            activePageSize: this.PageSizeOptions[0],
            activePageNo: 1,
            lastPageNo: 10,
            TotalRecord: 100,
            StartRecordNo: 1,
            LastRecordNo: 10,
            collapse: -1,
            PartDetails: {}
        }

    }

    toggle(e, item) {
        const { tableName, onRowClick } = this.props;
        if (onRowClick) onRowClick(item);

        if (tableName) {
            let event = e.target.dataset.event;
            this.setState({ collapse: this.state.collapse === Number(event) ? -1 : Number(event) });
        }

        if (tableName === "Parts") {
            this.setState({ PartDetails: item, partCost: this.covert2decimal(item.partCost) });
        } else if (tableName === "Comments") {
            this.setState({ CommentDetails: item });
        }
    }

    showHideSideFilter = () => {
        let showSidebar = !this.state.showSidebar;
        this.setState({ showSidebar: showSidebar });
        this.props.showHideSideFilter(showSidebar);
    }
    handleAddComment = val => {
        this.setState({ openAddComment: val, NewComment: '', NewCommentError: false });
    }
    setDropdown = val => {
        this.setState({ dropdownOpen: val });
    }
    handleExport = val => {
        this.setDropdown(false);
        this.props.handleExport(val, false);
    }
    setPageSizeDropdown = val => {
        this.setState({ PageSizeOpen: val });
    }
    handlePageNo = val => {
        let activePageNo = this.state.activePageNo;
        let newPgeNo = val === 'prev' ? activePageNo - 1 : activePageNo + 1;
        this.props.handlePageNo(newPgeNo);
        this.setState({ activePageNo: newPgeNo }, () => {
            this.handleDisplayNumber();
        });
    }
    handlePageSize = page => {
        let activePageNo = this.state.activePageNo;
        let totalRecords = this.props.totalRecords;

        let newLastPagePossible = Math.ceil(totalRecords / page);
        if (newLastPagePossible < activePageNo) activePageNo = newLastPagePossible;

        this.setPageSizeDropdown(false);
        this.props.handlePageSize(page, activePageNo);
        this.setState({ activePageSize: page, activePageNo: activePageNo }, () => {
            this.handleDisplayNumber();
        })
    }

    handleDisplayNumber = () => {
        const { totalRecords } = this.props;
        const { activePageNo, activePageSize } = this.state;

        if (activePageNo === 1) {
            this.setState({ StartRecordNo: 1, LastRecordNo: activePageSize > totalRecords ? totalRecords : activePageSize });
        } else {
            let StartRecordNo = (activePageSize * (activePageNo - 1)) + 1;
            let LastRecordNo = StartRecordNo + +activePageSize - 1;
            if (LastRecordNo > totalRecords) LastRecordNo = totalRecords;

            this.setState({ StartRecordNo: StartRecordNo, LastRecordNo: LastRecordNo });
        }
    }

    handleSorting = sortCol => {
        const { sortDir, sortColumn, handleSorting } = this.props;
        let NewSortDir = "asc";

        if (sortCol === sortColumn) {
            NewSortDir = sortDir === "desc" ? "asc" : "desc";
        }

        handleSorting(NewSortDir, sortCol);
    }

    AddComment = () => {
        let NewComment = this.state.NewComment;
        if (NewComment) {
            this.props.UpdatePODetail('Comments', NewComment);
            this.setState({ openAddComment: false, NewComment: '', collapse: -1 });
        } else {
            this.setState({ NewCommentError: true });
        }
    }
    SavePartCost = () => {
        let { partCost, PartDetails } = this.state;

        PartDetails.partCost = this.covert2decimal(partCost);
        this.props.UpdatePODetail('Parts', PartDetails);
        this.setState({ collapse: -1 });
    }

    covert2decimal = val => {
        return parseFloat(val).toFixed(2);
    }
    renderTableHeader(data, columns) {
        const { sortDir, sortColumn } = this.props;

        if (data && data.length) {
            let header = [];
            columns.map(ob => header.push(ob.key));

            return header.map((key, index) => {
                let value = columns.find(ob => ob.key === key);

                if (value) {
                    return <th style={{ minWidth: value.width ? value.width : value.name === "DATE" ? "100px" : value.name === "COMMENT" ? "400px" : 'inherit', width: value.width }} className={` ${value.type === "currency" ? 'rightAligned' : ''} `} key={index}>
                        <span className={` ${value.sort ? "pointer" : ''}  `} onClick={() => value.sort ? this.handleSorting(value.key) : ''} >{value.name}

                            {/* sorting icons start */}
                            {sortColumn === value.key && value.sort && sortDir === "desc" ?
                                <FaSortAmountUp className="ms-1" /> :
                                sortColumn === value.key && value.sort && sortDir === "asc" ?
                                    <FaSortAmountDownAlt className="ms-1" /> :
                                    value.sort ? <FaSortAmountDownAlt className="ms-1 opaque" /> : ''
                            }
                            {/* sorting icons end */}
                        </span>
                    </th>
                }
            });
        } else {
            return columns.map((col, index) => {
                return <th key={index}>{col.name}</th>
            });
        }
    }

    renderTableData(data, columns) {
        const { collapse } = this.state;
        const { onRowClick, disabled, screenName, resetPagination, tableName } = this.props;

        let header = [];
        columns.map(ob => header.push(ob.key))

        if (resetPagination) {
            this.setState({ activePageNo: 1 }, ob => this.handleDisplayNumber());
        }

        return data && data.length ? data.map((item, index) => {
            return (<>

                <tr data-event={index} onClick={(e) => item ? this.toggle(e, item) : ''} key={index}>
                    {header.map((key, index1) => {
                        let value = columns.find(ob => ob.key === key);

                        // for arrow
                        if (value && value.key === "arrow") {
                            return <>
                                <td style={{ width: "20px" }} data-event={index} className={`${onRowClick ? 'pointer' : ''}`} key={index1}>
                                    {collapse !== index ? <div className="arrow rightArrow"></div> : <div className="arrow downArrow"></div>}
                                </td>
                            </>
                        } else if (value && value.type === 'checkbox') {
                            return <td data-event={index} key={index1} >
                                <div className="detail-check">
                                    <div className="form-check">
                                        <Input
                                            disabled={disabled}
                                            onChange={() => onRowClick ? onRowClick(item) : null}
                                            className="form-check-input pointer"
                                            type="checkbox"
                                            defaultChecked={key === "check loss code" ? item['code'] : item[key] === "true"}
                                            id={index1}
                                        />
                                    </div>
                                </div>
                            </td>

                            //
                        } else if (value && value.key === 'status') {
                            let Options = screenName === "PURCHASE ORDERS" ? consts.PoStatusOptions : consts.ClaimStatusOptions;
                            let selectedVal = item[key] ? Options.find(ob => ob.value === item[key])?.name : '';

                            return <>
                                <td data-event={index} className={`${onRowClick ? 'pointer ' : ''} ${item.class && value.key === 'comment' ? item.class : ''}`} key={index1}>{selectedVal}</td>

                            </>

                            //  for type==viewbutton
                        } else if (value && value.type === 'viewButton') {
                            return <td data-event={index} key={index1} className={`${onRowClick ? 'pointer' : ''}`} >
                                <span className="floatRight">
                                    <button className="table-modal " type="button" data-bs-toggle="modal"
                                        data-bs-target="#siteModal" aria-label="togglrimg">
                                        <span data-event={index} onClick={(e) => item ? this.toggle(e, item) : ''} className="viewComment pointer h6">View</span>
                                    </button>
                                </span>
                            </td>

                            // for type==text
                        } else if (value) {

                            // deciding color in case of comments
                            let commentColor = '';
                            if (value.key === 'comment') {
                                commentColor = item.commentType === "PYMT" ? 'color-success' : item.commentType === 'CLAIM' ? 'color-danger' : item.commentType === "PO" ? 'color-default' : 'inherit';
                            }

                            let isCurrency = this.currencyKeys.indexOf(key) !== -1;

                            return <td data-event={index} style={{ maxWidth: value.width ? value.width : 'inherit' }} className={`${onRowClick ? 'CellEllipsis' : ''} ${isCurrency ? 'rightAligned' : ''}  ${commentColor}`} key={index1}>{isCurrency ? '$' + (Math.round(item[key] * 100) / 100).toFixed(2) : key === "zip" && item[key] ? item[key].slice(0, 5) : key === "comment" && item[key] && item[key].length > 100 ? item[key].slice(0, 100) + '...' : item[key]}</td>
                        }
                    })}

                </tr>

                {collapse === index && tableName === "Parts" ? this.PartTableCollapse() : collapse === index && tableName === "Comments" ? this.CommentTableCollapse(collapse, index) : ''}

            </>
            )
        }) :
            <tr key={13}><td key={34} colSpan="10" className="h5 p-3">Sorry, no data found</td></tr>;

    }

    CommentTableCollapse = (collapse, index) => {
        let { CommentDetails } = this.state;

        return <tr className="DetailsCollapse"><td></td><td colSpan="10" className="cardSubItem">
            <Collapse isOpen={collapse === index}>
                <CardBody className="p-0">
                    <Row>
                        <Col md={8}>
                            <Row className="claim-number">
                                <Col md={2} className="font-main mb-2">Made By</Col>
                                <Col md={10} className="font-main mb-2"><span className="floatLeft colllapseLabel" >{CommentDetails.madeBy ? CommentDetails.madeBy : 'Unknown'}</span></Col>
                            </Row>
                            <Row className="claim-number">
                                <Col md={2} className="font-main">Comment</Col>
                                <Col md={10} className="font-main"><span className="floatLeft colllapseLabel whiteSpace" >{CommentDetails.comment}</span></Col>
                            </Row>
                        </Col>

                        <Col md={4}>
                            <Row className="claim-number">
                                <Col md={6} className="font-main mb-2">Comment Reason</Col>
                                <Col md={6} className="font-main mb-2"><span className="floatLeft colllapseLabel" >{CommentDetails.commentReason}</span></Col>
                            </Row>
                            {this.props.showAmount !== false && <Row className="claim-number">
                                <Col md={6} className="font-main">Amount</Col>
                                <Col md={6} className="font-main"><span className="floatLeft colllapseLabel" >{'$' + (Math.round(CommentDetails.amount * 100) / 100).toFixed(2)} </span></Col>
                            </Row>}
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </td></tr>
    }

    PartTableCollapse = (collapse, index) => {
        let { PartDetails, partCost } = this.state;

        return <tr className="DetailsCollapse"><td></td><td colSpan="10" className="cardSubItem">
            <Collapse isOpen={collapse === index}>
                <CardBody className="p-0">
                    <Row>
                        <Col md={4}>
                            <Row className="claim-number">
                                <Col md={5} className="font-main mb-2">Cover#</Col>
                                <Col md={7} className="font-main mb-2"><span className="floatLeft colllapseLabel" >{PartDetails.coverNumber ? PartDetails.coverNumber : '-'}</span></Col>
                            </Row>
                            <Row className="claim-number">
                                <Col md={5} className="font-main mb-3">Group (Lot)</Col>
                                <Col md={7} className="font-main mb-3"><span className="floatLeft colllapseLabel" >{PartDetails.groupLot ? PartDetails.groupLot : '-'}</span></Col>
                            </Row>
                        </Col>
                        <Col md={4}>
                            <Row className="claim-number">
                                <Col md={5} className="font-main mb-2">Item ID</Col>
                                <Col md={7} className="font-main mb-2"><span className="floatLeft colllapseLabel" >{PartDetails.itemId ? PartDetails.itemId : '-'}</span></Col>
                            </Row>
                            <Row className="claim-number">
                                <Col md={5} className="font-main mb-2">Style Info</Col>
                                <Col md={7} className="font-main mb-2"><span className="floatLeft colllapseLabel" >{PartDetails.styleInfo ? PartDetails.styleInfo : '-'}</span></Col>
                            </Row>
                        </Col>
                        <Col>
                            <Row className="claim-number">
                                <Col md={5} className="font-main mb-0"> Part Cost</Col>
                                <Col md={5} >
                                    <span class="currencyInput">
                                        <Input
                                            type="number"
                                            min="0.01"
                                            step="0.01"
                                            id="partCost"
                                            name="partCost"
                                            className="form-control noArrows"
                                            maxLength={10}
                                            onChange={e => {
                                                this.setState({ partCost: e.target.value });
                                            }}
                                            value={partCost}
                                        />

                                        {!partCost ? <div className="input-error">Required</div> : <div className="reqSubstitude"></div>}

                                    </span>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={10} className="font-main mt-2"><span className="floatRight" >
                                    <button type="button" onClick={this.SavePartCost} className="btn-web">SAVE</button>
                                </span></Col>
                            </Row>
                        </Col>
                    </Row>
                </CardBody>
            </Collapse>
        </td></tr>
    }

    render() {
        let { showSidebar, dropdownOpen, PageSizeOpen, activePageSize, activePageNo, searchValue, StartRecordNo, LastRecordNo, singleCollapseItem, openAddComment, NewComment, NewCommentError } = this.state;

        let { screenName, Data, Columns, headerFooter, search, pagination, tableClassName, totalRecords, tableName, AddCommentBtn, overflowVis } = this.props;

        let lastPageNo = Math.ceil(totalRecords / activePageSize);

        if (!singleCollapseItem && Data && Data.length === 1 && tableName === "Parts") {
            this.setState({ collapse: 0, PartDetails: Data[0], partCost: this.covert2decimal(Data[0].partCost), singleCollapseItem: true });
        }

        return (
            <div>
                {headerFooter ? <div className={showSidebar ? 'header1' : 'header'} >
                    <DefaultHeader {...this.props}></DefaultHeader>
                </div> : null}

                <div className={headerFooter ? "inner-container justify-content-center container-fluid" : "justify-content-center"}>
                    {showSidebar ? <span onClick={this.showHideSideFilter} className="closee"></span> : null}

                    {screenName ? <div className="col-12">
                        <div className="heading-flex mb-20">
                            <h1 className="section-title darkcolor font-main">{screenName}</h1>

                            <Dropdown isOpen={dropdownOpen} onMouseLeave={() => this.setDropdown(false)} onMouseOver={() => this.setDropdown(true)} toggle={() => this.setDropdown(true)} className="btn-export">
                                <DropdownToggle color="primary" caret ><img alt="export now" src={require('../../assets/images/export.png').default} />  EXPORT </DropdownToggle>
                                <DropdownMenu onMouseOver={() => this.setDropdown(true)} onMouseLeave={() => this.setDropdown(false)}>
                                    <DropdownItem className="pointer" text><div onClick={() => this.handleExport('pdf')}>PDF Report</div></DropdownItem>

                                    <DropdownItem className="pointer" text><div onClick={() => this.handleExport('csv')}>CSV Download</div></DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </div>
                    </div> : null}
                    <div className="col-12"><div className="table-wrapper">
                        {search ? <div className="table-header">

                            <form className="form-search">
                                <Label for="searchrcd" className="d-none">Search</Label>
                                <InputGroup>
                                    <button className="btn-search" aria-labelledby="searchrcd">
                                        <img alt="" src={require('../../assets/images/search.png').default} />
                                    </button>
                                    <Input
                                        type="search"
                                        id="searchrcd"
                                        value={searchValue}
                                        placeholder="Search"
                                        className="TableSearch"
                                        onChange={this.props.handleSearch}
                                        autoComplete="off"
                                    />
                                </InputGroup>
                            </form>

                            <button title="Advanced Filter" onClick={this.showHideSideFilter} type="button" className="SideFilterBtn btn btn-default"> <img alt="" src={require('.././../assets/images/filter.png').default} /> FILTERS</button>

                        </div> : null}

                        <div className={`table-responsive hover ${tableName ? 'tableContainer' : ''} ${overflowVis ? 'overflowVis' : ''} `}>
                            {tableName && <div className="section-title font-main darkcolor mb-2" >

                                <span>{tableName}</span>
                                {AddCommentBtn && <div className="floatRight mb-2" style={{ position: 'relative' }}>

                                    <Dropdown isOpen={openAddComment} toggle={() => this.handleAddComment(!openAddComment)} className="AddCommentDropdown">
                                        <DropdownToggle color="primary" caret ><img alt="export now" src={require('../../assets/images/export.png').default} />  ADD COMMENTS </DropdownToggle>

                                        <DropdownMenu right>
                                            <CardBody className="p-0">
                                                <button onClick={() => this.handleAddComment(false)} type="button" className="btn-close commentClose closeBtn" data-bs-dismiss="modal" aria-label="Close"></button>
                                                <Row>
                                                    <Col md={12}>
                                                        <Label for="mMsg"> Comments </Label>
                                                        <textarea
                                                            id="Comments"
                                                            className="form-control"
                                                            value={NewComment}
                                                            onChange={(e) => this.setState({ NewCommentError: false, NewComment: e.target.value })}
                                                            name="comment"
                                                        ></textarea>
                                                        {NewCommentError ? <div className="input-error">Required</div> : <div className="reqSubstitude"></div>}
                                                    </Col>
                                                </Row>
                                                <div className="floatRight"><button onClick={this.AddComment} type="button" className="SaveCommentBtn btn-web"> SAVE </button></div>
                                            </CardBody>
                                        </DropdownMenu>
                                    </Dropdown>
                                </div>}
                            </div>}
                            <div className={`${tableName === "Comments" ? 'tableFixHead' : ''}`}>
                                <table className={`table mb-0 ${tableClassName ? tableClassName : ''} `}>
                                    <thead>
                                        <tr key={3}>
                                            {this.renderTableHeader(Data, Columns)}
                                        </tr>
                                    </thead>

                                    <tbody >
                                        {this.renderTableData(Data, Columns)}
                                    </tbody>

                                </table>
                            </div>
                        </div>
                        {pagination ? <div className="table-footer">
                            <div className="dropdown table-dropdown">
                                <Dropdown isOpen={PageSizeOpen} toggle={() => this.setPageSizeDropdown(true)} onMouseOver={() => this.setPageSizeDropdown(true)} onMouseLeave={() => this.setPageSizeDropdown(false)}>
                                    <DropdownToggle caret tag="a" className="nav-link pointer"> Rows per page: {activePageSize} </DropdownToggle>
                                    <DropdownMenu className="pointer tablePagination" onMouseOver={() => this.setPageSizeDropdown(true)}>

                                        {this.PageSizeOptions.map((ob) => <DropdownItem text> <div onClick={() => this.handlePageSize(ob)} >{ob}</div></DropdownItem>)}
                                    </DropdownMenu>
                                </Dropdown>
                            </div>

                            <div className="right-side">

                                <p className="per-row ml-0">{!Data.length ? 0 : StartRecordNo}-{!Data.length ? 0 : activePageNo === 1 ? Data.length : LastRecordNo} of {totalRecords}</p>
                                <div className="table-navigation">
                                    <span onClick={() => activePageNo !== 1 ? this.handlePageNo('prev') : null} className={`table-prev ${activePageNo === 1 ? 'disabled' : ''}`}>
                                        <img alt="" src={require('../../assets/images/left.png').default} />
                                    </span>
                                    <span onClick={() => activePageNo !== lastPageNo ? this.handlePageNo('next') : null} className={`table-next ${activePageNo === lastPageNo || !Data.length ? 'disabled' : ''}`}>
                                        <img alt="" src={require('../../assets/images/right.png').default} />
                                    </span>
                                </div>
                            </div>
                        </div> : null}
                    </div>
                    </div>
                </div>
                {headerFooter ? <div className={showSidebar ? 'footer1' : 'footer'}>
                    <DefaultFooter ></DefaultFooter>
                </div> : null}
            </div>
        );
    }
}

var TableGridModule = connect(null)(withRouter(TableGrid));
export default TableGridModule;